import React, { Component } from 'react'
import PropTypes from 'prop-types'

import TextField from './TextField'

class ChoiceDisplayField extends Component {
  static propTypes = {
    addLabel: PropTypes.bool,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
    choiceName: PropTypes.object.isRequired,
  };

  static defaultProps = {
    addLabel: true,
  };

  render() {
    const { source, record, choiceName } = this.props;
    const newRecord = {
      [source]: choiceName[record[source]]
    };

    return (
      <TextField {...this.props} record={newRecord}/>
    )
  }
}

export default ChoiceDisplayField;


// WEBPACK FOOTER //
// ./src/components/field/ChoiceDisplayField.js